import { Form, Input, Row, Select, Typography, Col, InputNumber } from "antd";
import React from "react";
import { labelConfig } from "../../../../customer/customer.config";
import { BOM } from "../../../../../services/definedMethod";

const { Text } = Typography;

const TermsForm = (props) => {
  const {
    onFinish,
    form,
    initialValues,
    interestCompoundingPeriodTypeOptions,
    interestPostingPeriodTypeOptions,
    interestCalculationTypeOptions,
    interestCalculationDaysInYearTypeOptions,
  } = props;

  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      initialValues={initialValues}
    >
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Default Deposit Amount</Text>}
            name={"depositAmount"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <InputNumber
              style={{ width: "100%" }}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
              placeholder="50,000"
              className="of-bold-disable-input"
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Minimum Deposit Amount</Text>}
            name={"minDepositAmount"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <InputNumber
              style={{ width: "100%" }}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
              placeholder="10,000"
              className="of-bold-disable-input"
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Maximum Deposit Amount</Text>}
            name={"maxDepositAmount"}
            rules={[{ required: true, message: "Required Field" }]}
          >
            <InputNumber
              style={{ width: "100%" }}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
              placeholder="20,000"
              className="of-bold-disable-input"
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Interest Compounding Period</Text>}
            name="interestCompoundingPeriodType"
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.interestCompoundingPeriod,
                "select"
              )}
              options={interestCompoundingPeriodTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Interest Posting Period</Text>}
            name="interestPostingPeriodType"
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.interestPostingPeriod,
                "select"
              )}
              options={interestPostingPeriodTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Interest Calculated Using</Text>}
            name="interestCalculationType"
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.interestCalculatedUsing,
                "select"
              )}
              options={interestCalculationTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text strong>Days In Year</Text>}
            name="interestCalculationDaysInYearType"
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.daysInYear,
                "select"
              )}
              options={interestCalculationDaysInYearTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default TermsForm;
